import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outerContainer: {
            gap: remCalc(24),
            // paddingBottom: remCalc(32),
            alignItems: 'stretch',
        },
        container: {
            columns: {base: 1, lg: 2},
            gap: remCalc(24),
            alignItems: 'flex-start',
        },
        column: {
            gap: remCalc(24),
            w: '100%',
        },
        field: {
            w: '100%',
            paddingY: remCalc(8),
        },
        heading: {
            textStyle: 'body-small',
            color: 'text.default',
            fontWeight: 'bold',
        },
        fieldSubtitle: {
            textStyle: 'body-xxsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
        },
        telephoneField: {
            gap: remCalc(8),
            w: '100%',
            paddingY: remCalc(8),
            alignItems: 'flex-start',
        },
    },
}
